export var Status;
(function (Status) {
    Status["success"] = "success";
    Status["failure"] = "failure";
})(Status || (Status = {}));
export const success = (dependencies) => ({
    status: Status.success,
    hasPartialDependencies: () => false,
    dependencies,
});
export const failure = (dependencies) => ({
    status: Status.failure,
    hasPartialDependencies: () => true,
    dependencies,
});
export const successOrFailure = (condition) => condition ? success : failure;
export const combine = (base, other) => successOrFailure(!base.hasPartialDependencies() && !other.hasPartialDependencies())(Object.assign(Object.assign({}, base.dependencies), other.dependencies));
//# sourceMappingURL=result.js.map